import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CxSchedularService } from './cx-schedular.service';

@Component({
  selector: 'cx-schedular',
  templateUrl: './cx-schedular.component.html',
})
export class CxSchedularContainerComponent implements OnInit, OnChanges {
  SCREENS = this.cxSchedularService.SCREENS;
  @Input() module = '';
  @Input() views: any[] = [];
  @Output() close = new EventEmitter();
  @Output() create = new EventEmitter();
  
  constructor( public cxSchedularService: CxSchedularService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['module']) {
      this.cxSchedularService.module = changes['module'].currentValue;
    }
  }

  ngOnInit(): void {
    if (!this.module) {
      throw new Error(`CxSchedular Module is required.`);
    }

    this.cxSchedularService.getData();
  }

  onClose() {
    this.cxSchedularService.currentScreen = this.SCREENS.ONE;
    this.close.emit('');
  }
}
